// extracted by mini-css-extract-plugin
export var dataCell = "_s0-2";
export var dataRow = "_s0-0";
export var headerRow = "_s0-1";